import { z } from 'zod';

export const verificationCheckboxSchema = z.literal(true, {
  // i18n.t('nif:validation.verification_checkbox_required', 'Please confirm to proceed')
  errorMap: () => ({
    message: 'nif:validation.verification_checkbox_required',
  }),
});
